// /**
//  * ContactForm Component
//  * 
//  * Form with real-time validation and EmailJS integration.
//  */

// import { useState, useCallback, useEffect } from 'react'
// import emailjs from '@emailjs/browser'
// import { useModal } from '../context/ModalContext'
// import { useFormValidation } from '../hooks/useFormValidation'
// import { EMAILJS_CONFIG, isEmailJSConfigured } from '../config/emailjs'
// import '../styles/ContactForm.css'

// function ContactForm({ selectedPlan, firstFocusableRef }) {
//   const { closeModal } = useModal()
//   const [isLoading, setIsLoading] = useState(false)
//   const [isSuccess, setIsSuccess] = useState(false)
//   const [formError, setFormError] = useState('')

//   const {
//     values,
//     errors,
//     handleChange,
//     handleBlur,
//     validateForm,
//     resetForm,
//     getFieldStatus
//   } = useFormValidation()

//   /**
//    * Initialize EmailJS
//    */
//   useEffect(() => {
//     if (EMAILJS_CONFIG.PUBLIC_KEY) {
//       emailjs.init(EMAILJS_CONFIG.PUBLIC_KEY)
      
//       if (EMAILJS_CONFIG.DEBUG_MODE) {
//         console.log('EmailJS initialized')
//       }
//     }
//   }, [])

//   /**
//    * Reset form when modal opens
//    */
//   useEffect(() => {
//     resetForm()
//     setIsSuccess(false)
//     setFormError('')
//   }, [selectedPlan, resetForm])

//   /**
//    * Handle form submission
//    */
//   const handleSubmit = useCallback(async (e) => {
//     e.preventDefault()
//     setFormError('')

//     // Validate form
//     if (!validateForm()) {
//       return
//     }

//     setIsLoading(true)

//     // Prepare form data
//     const formData = {
//       fullName: values.fullName.trim(),
//       email: values.email.trim(),
//       whatsappNumber: values.whatsappNumber.trim(),
//       cardType: selectedPlan.type,
//       price: selectedPlan.price,
//       submissionDate: new Date().toLocaleString('de-DE', {
//         dateStyle: 'full',
//         timeStyle: 'medium'
//       }),
//       to_email: EMAILJS_CONFIG.RECIPIENT_EMAIL
//     }

//     if (EMAILJS_CONFIG.DEBUG_MODE) {
//       console.log('Form data:', formData)
//     }

//     try {
//       // Send email if EmailJS is configured
//       if (isEmailJSConfigured()) {
//         await emailjs.send(
//           EMAILJS_CONFIG.SERVICE_ID,
//           EMAILJS_CONFIG.TEMPLATE_ID,
//           formData
//         )
//       } else {
//         // Simulate success if not configured
//         if (EMAILJS_CONFIG.DEBUG_MODE) {
//           console.warn('EmailJS not configured. Simulating success.')
//         }
//         await new Promise(resolve => setTimeout(resolve, 1500))
//       }

//       // Show success
//       setIsSuccess(true)

//       // Auto-close modal after 3 seconds
//       setTimeout(() => {
//         closeModal()
//         resetForm()
//         setIsSuccess(false)
//       }, 3000)

//     } catch (error) {
//       console.error('Form submission error:', error)
//       setFormError('Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.')
//     } finally {
//       setIsLoading(false)
//     }
//   }, [values, selectedPlan, validateForm, closeModal, resetForm])

//   // Show success message
//   if (isSuccess) {
//     return (
//       <div className="success-message show">
//         <div className="success-icon">
//           <i className="fas fa-check-circle" aria-hidden="true"></i>
//         </div>
//         <h3>Vielen Dank!</h3>
//         <p>Wir werden Sie bald kontaktieren.</p>
//       </div>
//     )
//   }

//   return (
//     <form onSubmit={handleSubmit} noValidate>
//       {/* Form Error Message */}
//       {formError && (
//         <div className="form-error-message show" role="alert">
//           <i className="fas fa-exclamation-triangle" aria-hidden="true"></i>
//           <span>{formError}</span>
//         </div>
//       )}

//       {/* Full Name Field */}
//       <div className="form-group">
//         <label htmlFor="fullName" className="form-label">
//           <i className="fas fa-user" aria-hidden="true"></i>
//           Vollständiger Name <span className="required">*</span>
//         </label>
//         <input
//           ref={firstFocusableRef}
//           type="text"
//           id="fullName"
//           name="fullName"
//           className={`form-input ${getFieldStatus('fullName')}`}
//           placeholder="Max Mustermann"
//           value={values.fullName}
//           onChange={handleChange}
//           onBlur={handleBlur}
//           required
//           aria-required="true"
//           aria-describedby="fullNameError"
//           aria-invalid={errors.fullName ? 'true' : 'false'}
//         />
//         <span 
//           className="error-message" 
//           id="fullNameError" 
//           role="alert"
//           aria-live="polite"
//         >
//           {errors.fullName}
//         </span>
//       </div>

//       {/* Email Field */}
//       <div className="form-group">
//         <label htmlFor="email" className="form-label">
//           <i className="fas fa-envelope" aria-hidden="true"></i>
//           E-Mail-Adresse <span className="required">*</span>
//         </label>
//         <input
//           type="email"
//           id="email"
//           name="email"
//           className={`form-input ${getFieldStatus('email')}`}
//           placeholder="ihre.email@beispiel.de"
//           value={values.email}
//           onChange={handleChange}
//           onBlur={handleBlur}
//           required
//           aria-required="true"
//           aria-describedby="emailError"
//           aria-invalid={errors.email ? 'true' : 'false'}
//         />
//         <span 
//           className="error-message" 
//           id="emailError" 
//           role="alert"
//           aria-live="polite"
//         >
//           {errors.email}
//         </span>
//       </div>

//       {/* WhatsApp Number Field */}
//       <div className="form-group">
//         <label htmlFor="whatsappNumber" className="form-label">
//           <i className="fab fa-whatsapp" aria-hidden="true"></i>
//           WhatsApp-Nummer <span className="required">*</span>
//         </label>
//         <input
//           type="tel"
//           id="whatsappNumber"
//           name="whatsappNumber"
//           className={`form-input ${getFieldStatus('whatsappNumber')}`}
//           placeholder="+49 123 456789"
//           value={values.whatsappNumber}
//           onChange={handleChange}
//           onBlur={handleBlur}
//           required
//           aria-required="true"
//           aria-describedby="whatsappError"
//           aria-invalid={errors.whatsappNumber ? 'true' : 'false'}
//         />
//         <span 
//           className="error-message" 
//           id="whatsappError" 
//           role="alert"
//           aria-live="polite"
//         >
//           {errors.whatsappNumber}
//         </span>
//       </div>

//       {/* Submit Button */}
//       <button 
//         type="submit" 
//         className={`submit-btn ${isLoading ? 'loading' : ''}`}
//         disabled={isLoading}
//       >
//         <span className="btn-text">Anfrage Absenden</span>
//         <span className="btn-loading" aria-hidden={!isLoading}>
//           <i className="fas fa-spinner fa-spin"></i>
//           Wird gesendet...
//         </span>
//         <i className="fas fa-paper-plane btn-icon" aria-hidden="true"></i>
//       </button>
//     </form>
//   )
// }

// export default ContactForm


/**
 * ContactForm Component
 * 
 * Form with real-time validation and EmailJS integration.
 */

import { useState, useCallback, useEffect } from 'react'
import emailjs from '@emailjs/browser'
import { useModal } from '../context/ModalContext'
import { useFormValidation } from '../hooks/useFormValidation'
import { EMAILJS_CONFIG, isEmailJSConfigured } from '../config/emailjs'
import '../styles/ContactForm.css'

function ContactForm({ selectedPlan, firstFocusableRef }) {
  const { closeModal } = useModal()
  const [isLoading, setIsLoading] = useState(false)
  const [isSuccess, setIsSuccess] = useState(false)
  const [formError, setFormError] = useState('')

  const {
    values,
    errors,
    handleChange,
    handleBlur,
    validateForm,
    resetForm,
    getFieldStatus
  } = useFormValidation()

  /**
   * Initialize EmailJS
   */
  useEffect(() => {
    if (EMAILJS_CONFIG.PUBLIC_KEY) {
      emailjs.init(EMAILJS_CONFIG.PUBLIC_KEY)
      
      if (EMAILJS_CONFIG.DEBUG_MODE) {
        console.log('EmailJS initialized')
      }
    }
  }, [])

  /**
   * Reset form when modal opens
   */
  useEffect(() => {
    resetForm()
    setIsSuccess(false)
    setFormError('')
  }, [selectedPlan, resetForm])

  /**
   * Handle form submission
   */
  const handleSubmit = useCallback(async (e) => {
    e.preventDefault()
    setFormError('')

    // Validate form
    if (!validateForm()) {
      return
    }

    setIsLoading(true)

    // Prepare form data
    const formData = {
      fullName: values.fullName.trim(),
      email: values.email.trim(),
      whatsappNumber: values.whatsappNumber.trim(),
      amount: values.amount.trim(),
      address: values.address.trim(),
      cardType: selectedPlan.type,
      price: selectedPlan.price,
      submissionDate: new Date().toLocaleString('de-DE', {
        dateStyle: 'full',
        timeStyle: 'medium'
      }),
      to_email: EMAILJS_CONFIG.RECIPIENT_EMAIL
    }

    if (EMAILJS_CONFIG.DEBUG_MODE) {
      console.log('Form data:', formData)
    }

    try {
      // Send email if EmailJS is configured
      if (isEmailJSConfigured()) {
        await emailjs.send(
          EMAILJS_CONFIG.SERVICE_ID,
          EMAILJS_CONFIG.TEMPLATE_ID,
          formData
        )
      } else {
        // Simulate success if not configured
        if (EMAILJS_CONFIG.DEBUG_MODE) {
          console.warn('EmailJS not configured. Simulating success.')
        }
        await new Promise(resolve => setTimeout(resolve, 1500))
      }

      // Show success
      setIsSuccess(true)

      // Auto-close modal after 3 seconds
      setTimeout(() => {
        closeModal()
        resetForm()
        setIsSuccess(false)
      }, 3000)

    } catch (error) {
      console.error('Form submission error:', error)
      setFormError('Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.')
    } finally {
      setIsLoading(false)
    }
  }, [values, selectedPlan, validateForm, closeModal, resetForm])

  // Show success message
  if (isSuccess) {
    return (
      <div className="success-message show">
        <div className="success-icon">
          <i className="fas fa-check-circle" aria-hidden="true"></i>
        </div>
        <h3>Vielen Dank!</h3>
        <p>Wir werden Sie bald kontaktieren.</p>
      </div>
    )
  }

  return (
    <form onSubmit={handleSubmit} noValidate>
      {/* Form Error Message */}
      {formError && (
        <div className="form-error-message show" role="alert">
          <i className="fas fa-exclamation-triangle" aria-hidden="true"></i>
          <span>{formError}</span>
        </div>
      )}

      {/* Full Name Field */}
      <div className="form-group">
        <label htmlFor="fullName" className="form-label">
          <i className="fas fa-user" aria-hidden="true"></i>
          Vollständiger Name <span className="required">*</span>
        </label>
        <input
          ref={firstFocusableRef}
          type="text"
          id="fullName"
          name="fullName"
          className={`form-input ${getFieldStatus('fullName')}`}
          placeholder="Max Mustermann"
          value={values.fullName}
          onChange={handleChange}
          onBlur={handleBlur}
          required
          aria-required="true"
          aria-describedby="fullNameError"
          aria-invalid={errors.fullName ? 'true' : 'false'}
        />
        <span 
          className="error-message" 
          id="fullNameError" 
          role="alert"
          aria-live="polite"
        >
          {errors.fullName}
        </span>
      </div>

      {/* Email Field */}
      <div className="form-group">
        <label htmlFor="email" className="form-label">
          <i className="fas fa-envelope" aria-hidden="true"></i>
          E-Mail-Adresse <span className="required">*</span>
        </label>
        <input
          type="email"
          id="email"
          name="email"
          className={`form-input ${getFieldStatus('email')}`}
          placeholder="ihre.email@beispiel.de"
          value={values.email}
          onChange={handleChange}
          onBlur={handleBlur}
          required
          aria-required="true"
          aria-describedby="emailError"
          aria-invalid={errors.email ? 'true' : 'false'}
        />
        <span 
          className="error-message" 
          id="emailError" 
          role="alert"
          aria-live="polite"
        >
          {errors.email}
        </span>
      </div>

      {/* WhatsApp Number Field */}
      <div className="form-group">
        <label htmlFor="whatsappNumber" className="form-label">
          <i className="fab fa-whatsapp" aria-hidden="true"></i>
          WhatsApp-Nummer <span className="required">*</span>
        </label>
        <input
          type="tel"
          id="whatsappNumber"
          name="whatsappNumber"
          className={`form-input ${getFieldStatus('whatsappNumber')}`}
          placeholder="+49 123 456789"
          value={values.whatsappNumber}
          onChange={handleChange}
          onBlur={handleBlur}
          required
          aria-required="true"
          aria-describedby="whatsappError"
          aria-invalid={errors.whatsappNumber ? 'true' : 'false'}
        />
        <span 
          className="error-message" 
          id="whatsappError" 
          role="alert"
          aria-live="polite"
        >
          {errors.whatsappNumber}
        </span>
      </div>

      {/* Amount Field */}
      <div className="form-group">
        <label htmlFor="amount" className="form-label">
          <i className="fas fa-euro-sign" aria-hidden="true"></i>
          Betrag <span className="required">*</span>
        </label>
        <input
          type="text"
          id="amount"
          name="amount"
          className={`form-input ${getFieldStatus('amount')}`}
          placeholder="100,00"
          value={values.amount}
          onChange={handleChange}
          onBlur={handleBlur}
          required
          aria-required="true"
          aria-describedby="amountError"
          aria-invalid={errors.amount ? 'true' : 'false'}
        />
        <span 
          className="error-message" 
          id="amountError" 
          role="alert"
          aria-live="polite"
        >
          {errors.amount}
        </span>
      </div>

      {/* Address Field */}
      <div className="form-group">
        <label htmlFor="address" className="form-label">
          <i className="fas fa-map-marker-alt" aria-hidden="true"></i>
          Adresse <span className="required">*</span>
        </label>
        <textarea
          id="address"
          name="address"
          className={`form-input ${getFieldStatus('address')}`}
          placeholder="Straße, Hausnummer, PLZ, Stadt"
          value={values.address}
          onChange={handleChange}
          onBlur={handleBlur}
          rows="3"
          required
          aria-required="true"
          aria-describedby="addressError"
          aria-invalid={errors.address ? 'true' : 'false'}
        />
        <span 
          className="error-message" 
          id="addressError" 
          role="alert"
          aria-live="polite"
        >
          {errors.address}
        </span>
      </div>

      {/* Submit Button */}
      <button 
        type="submit" 
        className={`submit-btn ${isLoading ? 'loading' : ''}`}
        disabled={isLoading}
      >
        <span className="btn-text">Anfrage Absenden</span>
        <span className="btn-loading" aria-hidden={!isLoading}>
          <i className="fas fa-spinner fa-spin"></i>
          Wird gesendet...
        </span>
        <i className="fas fa-paper-plane btn-icon" aria-hidden="true"></i>
      </button>
    </form>
  )
}

export default ContactForm